import { Grid } from "@material-ui/core";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import banner from "../images/banner.jpg";
import { getCookie } from 'typescript-cookie'
import { Member } from "../interfaces/Member";
import { useEffect, useState } from "react";

const RESORTS = [
    "Village at Palmetto Dunes",
    "Ocean Cove",
    "Spinnaker at Shipyard"
];

export function HiltonHeadIslandAdvantage() {
    const [owner, setOwner] = useState<Member>();
    const [showForm, setShowForm] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        requestedDates: '',
        preferredResort1: '',
        preferredResort2: '',
        bedrooms: '',
        additionalInfo: ''
    });

    useEffect(() => {
        const ownerCookie = getCookie('owner') || undefined;

        if (ownerCookie) {
            setOwner(JSON.parse(ownerCookie) as Member);
        } else {
            window.location.href = "/login";
        }
    }, [])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        const subject = encodeURIComponent("Epic Vacations VIP Hilton Head Island Resort Request");
        const body = encodeURIComponent(
            `Name: ${formData.name}\n` +
            `Email: ${formData.email}\n` +
            `Mobile: ${formData.mobile}\n` +
            `Requested Dates: ${formData.requestedDates}\n` +
            `Preferred Resort 1: ${formData.preferredResort1}\n` +
            `Preferred Resort 2: ${formData.preferredResort2}\n` +
            `Number of Bedrooms: ${formData.bedrooms}\n` +
            `Additional Info: ${formData.additionalInfo}`
        );

        window.location.href = `mailto:vacations@hiltonheadusa.com?subject=${subject}&body=${body}`;
        setSubmitted(true);
        setShowForm(false);
    };

    return (
        <div>

            {owner && <Header owner={owner} />}

            {owner &&
            <div>
                <Grid container>
                    <Grid item xs={12}>
                        <div style={{ width: '100%', margin: '0px' }}>
                            <img src={banner} style={{ width: '100%' }} alt='beach image' />
                        </div>
                        <div style={{
                            fontSize: '2.5em',
                            fontFamily: 'Assistant',
                            fontWeight: 'bold',
                            width: '100%',
                            textAlign: 'center',
                            margin: '10px'
                        }}>
                            Hilton Head Island Advantage
                        </div>
                    </Grid>
                </Grid>

                <Grid container style={{ marginBottom: '60px' }}>
                    <Grid item xs={12}>
                        <div style={{
                            margin: 'auto',
                            width: '60%',
                            lineHeight: '130%',
                            fontSize: '1.15em',
                            textAlign: 'center'
                        }}>
                            {/* Intro */}
                            <div style={{ fontSize: '1.1em', fontWeight: 'bold', marginBottom: '10px' }}>
                                Your Epic Vacations member perks&mdash;made for Hilton Head Island.
                            </div>
                            <div style={{ marginBottom: '30px' }}>
                                Welcome to your inside track on the Lowcountry. With the Hilton Head Island
                                Advantage, members get two easy ways to enjoy the island for less.
                            </div>

                            {/* Island Insider */}
                            <div className='tier-label'>Island Insider</div>
                            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                                Member-only savings on Hilton Head Island rentals.
                            </div>
                            <div>
                                Looking for the perfect villa, condo, or island escape? Island Insider gives
                                Epic Vacations members access to discounted rates on Hilton Head Island
                                rentals&mdash;with the flexibility to choose your dates, your location, and your vibe.
                            </div>
                            <div>
                                <a href="https://www.mywebrez.com/epicvacations" target="_blank" rel="noopener noreferrer">
                                    <button className='action-button' style={{ cursor: 'pointer', width: 'auto', padding: '10px 40px' }}>BOOK HERE</button>
                                </a>
                            </div>

                            {/* VIP Resort Access */}
                            <div className='tier-label'>VIP Hilton Head Island Resort Access</div>
                            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                                Unbeatable weekly pricing at iconic island resorts.
                            </div>
                            <div>
                                Unlock exclusive VIP pricing on weekly stays at Spinnaker at Shipyard,
                                Village at Palmetto Dunes, or Ocean Cove in Palmetto Dunes.
                            </div>

                            <div style={{ marginTop: '20px' }}>
                                <div style={{ fontWeight: 'bold', fontSize: '1.1em', marginBottom: '10px' }}>Weekly Member Pricing</div>
                                <div className='tier-sub-label'>Studios &amp; One Bedroom Villas</div>
                                <div>$450<sup>*</sup> / week</div>
                                <div className='tier-sub-label'>Two Bedroom Villas &amp; Townhomes</div>
                                <div>$550<sup>*</sup> / week</div>
                                <div className='tier-sub-label'>Two Bedroom w/ Loft &amp; Three Bedroom Villas</div>
                                <div>$650<sup>*</sup> / week</div>
                            </div>

                            <div className='tier-footnote'>
                                * Based on availability. Subject to black-out dates and holidays. Valid booking window is
                                60 days prior to check-in date.<br />Taxes and fees not included in above pricing. Pricing
                                subject to change at any time.
                            </div>

                            <div>
                                <button
                                    className='action-button'
                                    style={{ cursor: 'pointer', width: 'auto', padding: '10px 40px' }}
                                    onClick={() => { setShowForm(true); setSubmitted(false); }}
                                >
                                    SUBMIT A REQUEST
                                </button>
                            </div>

                            {submitted && !showForm && (
                                <div style={{
                                    backgroundColor: '#22a845',
                                    color: 'white',
                                    padding: '15px 20px',
                                    borderRadius: '8px',
                                    marginTop: '10px'
                                }}>
                                    Thank you! We've received your request. A team member will contact you as soon as
                                    possible with availability and pricing details.
                                </div>
                            )}
                        </div>
                    </Grid>
                </Grid>

                {/* Request Form Modal */}
                {showForm && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        zIndex: 1000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <div style={{
                            backgroundColor: '#fefefe',
                            borderRadius: '10px',
                            padding: '30px',
                            width: '500px',
                            maxHeight: '90vh',
                            overflowY: 'auto'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '15px'
                            }}>
                                <div style={{
                                    fontSize: '1.2em',
                                    fontWeight: 'bold',
                                    color: '#053e8f'
                                }}>
                                    Epic Vacations VIP Hilton Head Island Resort Request
                                </div>
                                <button
                                    onClick={() => setShowForm(false)}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '1.5em',
                                        cursor: 'pointer',
                                        color: '#666'
                                    }}
                                >
                                    &times;
                                </button>
                            </div>

                            <form onSubmit={handleSubmit}>
                                <div className='FormLabel'>Name</div>
                                <input className='FormInput' name='name' value={formData.name} onChange={handleChange} required />

                                <div className='FormLabel'>Email Address</div>
                                <input className='FormInput' name='email' type='email' value={formData.email} onChange={handleChange} required />

                                <div className='FormLabel'>Mobile #</div>
                                <input className='FormInput' name='mobile' type='tel' value={formData.mobile} onChange={handleChange} required />

                                <div className='FormLabel'>Requested Dates</div>
                                <input className='FormInput' name='requestedDates' type='date' value={formData.requestedDates} onChange={handleChange} required />

                                <div className='FormLabel'>Preferred Resort 1</div>
                                <select className='FormInput' name='preferredResort1' value={formData.preferredResort1} onChange={handleChange} required>
                                    <option value=''>Select a resort</option>
                                    {RESORTS.map(r => <option key={r} value={r}>{r}</option>)}
                                </select>

                                <div className='FormLabel'>Preferred Resort 2</div>
                                <select className='FormInput' name='preferredResort2' value={formData.preferredResort2} onChange={handleChange}>
                                    <option value=''>Select a resort</option>
                                    {RESORTS.map(r => <option key={r} value={r}>{r}</option>)}
                                </select>

                                <div className='FormLabel'>Number of Bedrooms</div>
                                <select className='FormInput' name='bedrooms' value={formData.bedrooms} onChange={handleChange} required>
                                    <option value=''>Select</option>
                                    <option value='1'>1</option>
                                    <option value='2'>2</option>
                                    <option value='3'>3</option>
                                </select>

                                <div className='FormLabel'>Additional Info</div>
                                <textarea className='FormInputTextArea' name='additionalInfo' value={formData.additionalInfo} onChange={handleChange} />

                                <button
                                    type='submit'
                                    className='action-button'
                                    style={{ cursor: 'pointer', width: '100%', marginTop: '15px' }}
                                >
                                    SUBMIT REQUEST
                                </button>
                            </form>
                        </div>
                    </div>
                )}
            </div>
            }

            {owner && <Footer />}
        </div>
    )
}